import { render, staticRenderFns } from "./AuditoriaMolexControlHallazgos.vue?vue&type=template&id=065cf118&scoped=true"
import script from "./AuditoriaMolexControlHallazgos.vue?vue&type=script&lang=js"
export * from "./AuditoriaMolexControlHallazgos.vue?vue&type=script&lang=js"
import style0 from "./AuditoriaMolexControlHallazgos.vue?vue&type=style&index=0&id=065cf118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065cf118",
  null
  
)

export default component.exports